import { ServiceError } from "../../../../../../../../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../../../../../../../../widget";
import { useDeleteStepModal } from "./useDeleteStepModal";

interface DeleteStepModalProps {
  show: boolean;
  closeModal: () => void;
  workflowUuid?: string;
  workflowStepUuid?: string;
  workflowStepRowVersion: number;
}

export const DeleteStepModal = ({
  show,
  closeModal,
  workflowUuid,
  workflowStepUuid,
  workflowStepRowVersion,
}: DeleteStepModalProps): JSX.Element => {
  const { handleDeleteStep, isHandleDeleteStepLoading, onCancel, errors } = useDeleteStepModal({
    closeModal,
    workflowUuid,
    workflowStepUuid,
    workflowStepRowVersion,
  });

  return (
    <Modal show={show} title="Delete step?" onClose={onCancel}>
      {errors && errors.length > 0 && (
        <Row spacingV="ll">
          <Column offset={3} span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <Row spacingV="ll" justify="center">
        <Column span={10} justify="center">
          <p className="body1">
            Deleting this step will permanently remove all associated tasks and their progress from the workflow. This
            action cannot be undone.
          </p>
        </Column>
      </Row>
      <form onSubmit={(e) => handleDeleteStep(e)}>
        <Row justify="center">
          <ActionButtons onCancel={onCancel} submitButtonLabel="Yes" isLoading={isHandleDeleteStepLoading} />
        </Row>
      </form>
    </Modal>
  );
};
